import {DynamicMediaPicture} from '@smart/web-components';
import React from 'react';
import styles from './leasing-trademark.module.scss';

type LeasingTrademarkType = {imagePath: string; externalLink?: string};

const leasingTrademarkBaseClass = `leasing-trademark`;

const LeasingTrademarkImage = ({imagePath}: {imagePath: string}) => {
  return (
    <DynamicMediaPicture
      imageUrl={imagePath}
      imageConfigs={[{sizes: `48px`, aspectRatio: `1-1`}]}
      imageAltText="leasing logotype"
      className={styles[`${leasingTrademarkBaseClass}__box`]}
      initialIsInView
    />
  );
};

export const LeasingTrademark = ({
  imagePath,
  externalLink,
}: LeasingTrademarkType) => {
  return (
    <div className={styles[`${leasingTrademarkBaseClass}__container`]}>
      {externalLink ? (
        <a href={externalLink}>
          <LeasingTrademarkImage imagePath={imagePath} />
        </a>
      ) : (
        <LeasingTrademarkImage imagePath={imagePath} />
      )}
    </div>
  );
};
